import { render, staticRenderFns } from "./HeaderLogoAdditional.vue?vue&type=template&id=9a2a2914"
import script from "./HeaderLogoAdditional.vue?vue&type=script&lang=ts"
export * from "./HeaderLogoAdditional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports